module.exports = __webpack_public_path__ + "img/lg_ring_r_e_0_0.ccffbf20.png";